'use strict';

const $ = window.jQuery;

const urlParams = new URLSearchParams(window.location.search);

export default class Products {
    constructor() {
        // Card correct translate title & terms
        if ($(window).width() > 767) {
            $('.card-product').each(function () {
                const excerptHeight = $(this).find('.card-product__excerpt').height();

                $(this).find('.card-product__terms, .card-product__title').css({
                    'transform': `translateY(${excerptHeight}px)`
                });
            });
        }

        // ////////////////////////////////////
        // ARCHIVE
        // ////////////////////////////////////
        if ($('body').hasClass('page-template-page-solutions')) {
            // On init
            const currentTaxonomy = urlParams.get('category');

            if (currentTaxonomy) {
                $(`.products-filters__button.is-${currentTaxonomy}`).addClass('is-active');
                $(`.card-product:not(.has-${currentTaxonomy})`).addClass('is-hidden');
            }

            // On filter button clicked
            $('.products-filters__button').on('click', function () {
                const taxonomy = $(this).data('taxonomy');

                if ($(this).hasClass('is-active')) {
                    urlParams.delete('category');

                    $('.products-filters__button').removeClass('is-active');
                    $('.card-product').removeClass('is-hidden');
                } else {
                    urlParams.set('category', taxonomy);

                    $('.products-filters__button').removeClass('is-active');
                    $(this).addClass('is-active');

                    $('.card-product').removeClass('is-hidden');
                    $(`.card-product:not(.has-${taxonomy})`).addClass('is-hidden');
                }

                history.replaceState(null, null, '?' + urlParams);
            });

            // On reset button clicked
            $('.products-filters__reset').on('click', function () {
                $('.products-filters__button').removeClass('is-active');
                $('.card-product').removeClass('is-hidden');
                urlParams.delete('category');
                history.replaceState(null, null, '?' + urlParams);
            });

            // On page loaded
            $('.products-filters, .products-list, .products-filters__reset').removeClass('is-loading');
        }

        // ////////////////////////////////////
        // SINGLE
        // ////////////////////////////////////
        if ($('body').hasClass('single-product')) {
            $('.is-anchor').each(function () {
                const anchorID = $(this).attr('id');
                const anchorText = $(this).data('anchor');
                const anchorType = $(this).data('type');

                $('#productAnchors').append(`<a class="product-anchors__item is-${anchorType}" href="#${anchorID}">${anchorText}</a>`);
            });
        }
    }
}
